import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import { formatUserName } from "@/v2-backoffice-client/user/user.utils"
import type { UserTenantFragment } from "@/v2-backoffice-client/user/tenant/__types__/user.tenant.fragment"
import TenantUserTypeSelectorDialogMenuItem from "@/v2-backoffice-client/tenant/user/type/TenantUserTypeSelectorDialogMenuItem"
import TenantUserRemoveMenuItem from "@/v2-backoffice-client/tenant/user/remove/TenantUserRemoveMenuItem"
import TenantUserRestoreMenuItem from "@/v2-backoffice-client/tenant/user/restore/TenantUserRestoreMenuItem"
import UserUpdateMenuItem from "@/v2-backoffice-client/user/update/UserUpdateMenuItem"
import UserCustomerUpdateSelectorDialogMenuItem from "@/v2-backoffice-client/user/customer/update/UserCustomerUpdateSelectorDialogMenuItem"
import UserResetPasswordMenuItem from "@/v2-backoffice-client/user/resetPassword/UserResetPasswordMenuItem"
import UserRevokeSessionsMenuItem from "@/v2-backoffice-client/user/revokeSessions/UserRevokeSessionsMenuItem"
import UserExternalToolMenuItems from "@/v2-backoffice-client/user/UserExternalToolMenuItems"
import UserStatusUpdateActions from "@/v2-backoffice-client/user/status/update/UserStatusUpdateActions"

export type TenantUserTableRowToolbarProps = {
  userTenant: UserTenantFragment
  tenantId: number
  onlyDeleted: boolean
  /** Remove/restore change which filter bucket the row belongs to — the
   *  list must refetch or the row lingers in the wrong view. */
  onMembershipChanged?(): void
}

function TenantUserTableRowToolbar(props: TenantUserTableRowToolbarProps) {
  const { userTenant, tenantId, onlyDeleted, onMembershipChanged } = props
  const user = userTenant.User
  const userName = formatUserName(user?.FirstName, user?.LastName)

  return (
    <ActionMenu>
      <ActionMenu.Trigger />

      <ActionMenu.Content>
        <TenantUserTypeSelectorDialogMenuItem userTenant={userTenant} />

        {onlyDeleted ? (
          <TenantUserRestoreMenuItem
            tenantId={tenantId}
            userId={userTenant.UserId}
            userName={userName}
            onCompleted={onMembershipChanged}
          />
        ) : (
          <TenantUserRemoveMenuItem
            tenantId={tenantId}
            userId={userTenant.UserId}
            userName={userName}
            onCompleted={onMembershipChanged}
          />
        )}

        <ActionMenu.Separator />

        <ActionMenu.Label>User Actions</ActionMenu.Label>

        <div className="pl-2">
          <UserExternalToolMenuItems user={user} />

          <ActionMenu.Separator />

          {user && <UserUpdateMenuItem user={user} />}
          {user && <UserCustomerUpdateSelectorDialogMenuItem user={user} />}

          <ActionMenu.Separator />

          {user && <UserResetPasswordMenuItem userId={user.Id} />}
          {user && <UserRevokeSessionsMenuItem userId={user.Id} />}
          {user && (
            <UserStatusUpdateActions
              userId={user.Id}
              currentStatusCode={user.UserStatusCode}
            />
          )}
        </div>
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default TenantUserTableRowToolbar
